/**
 * Blog Detail View Counter
 * sessionStorage를 사용한 블로그 상세 페이지 조회 수 관리
 */

const COUNT_KEY = 'viewCount';

/**
 * 현재 블로그 조회 수 반환
 * @returns {number|null} 조회 수 (없으면 null)
 */
export function getBlogViewCount() {
  const count = sessionStorage.getItem(COUNT_KEY);
  return count !== null ? parseInt(count, 10) : null;
}

/**
 * 블로그 조회 수 1 증가
 * @returns {number|null} 증가된 조회 수 (view count 없으면 null)
 */
export function incrementBlogViewCount() {
  const current = getBlogViewCount();
  if (current === null) {
    return null; // view count가 없으면 증가시키지 않음
  }
  const newCount = current + 1;
  sessionStorage.setItem(COUNT_KEY, newCount.toString());
  return newCount;
}

/**
 * 블로그 조회 수를 0으로 리셋
 * 도입문의 완료 시 또는 각 퍼널 단계 완료 시 호출
 * 같은 탭에서는 항상 같은 leadId이므로 leadId 비교 불필요
 */
export function resetBlogViewCount() {
  sessionStorage.setItem(COUNT_KEY, '0');
}

/**
 * 블로그 조회 수 완전 제거
 * 광고정보등록 완료 시 호출
 */
export function removeBlogViewCount() {
  sessionStorage.removeItem(COUNT_KEY);
}
